import { render, staticRenderFns } from "./SeizureGraphForMobile.vue?vue&type=template&id=72fb009d&"
import script from "./SeizureGraphForMobile.vue?vue&type=script&lang=js&"
export * from "./SeizureGraphForMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports